import { render, staticRenderFns } from "./OverseasWarehouse.vue?vue&type=template&id=452a46ac&"
import script from "./OverseasWarehouse.vue?vue&type=script&lang=js&"
export * from "./OverseasWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./OverseasWarehouse.vue?vue&type=style&index=0&lang=less&"
import style1 from "./OverseasWarehouse.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports